// @flow
import React from "react";
import fileDownload from "js-file-download";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import I18n from "../i18n/I18n";
import { put, call, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

export default (api: Object) => {
  /******
******
Deprecated Orders Will be removed later

****
***/

  /* Get Orders */
  function* getOrders(action) {
    try {
      const response = yield call(api.orders.getOrders, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getOrdersSuccess(response.data));
      } else {
        yield put(Actions.getOrdersFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getOrdersFailure(error));
    }
  }
  function* watchGetOrders(): Generator<void, void, void> {
    yield takeLatest(Types.GET_ORDERS, getOrders);
  }

  /* Post Orders */

  function* postOrders(action) {
    try {
      const response = yield call(api.orders.postOrders, action.orders);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.postOrdersSuccess(response.data));
        toast(
          I18n.getText(
            "order.accept-success",
            {},
            "Order accepted successfully"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.postOrdersFailure(response.data.error || "Error"));
        toast(response.data.error, { type: "error", className: "errorClass" });
      }
    } catch (error) {
      yield put(Actions.postOrdersFailure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchPostOrders(): Generator<void, void, void> {
    yield takeLatest(Types.POST_ORDERS, postOrders);
  }

  /* Get Reserved Orders */
  function* getReservedOrders(action) {
    try {
      const response = yield call(api.orders.getReservedOrders, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getReservedOrdersSuccess(response.data));
      } else {
        yield put(Actions.getReservedOrdersFailure(response.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getReservedOrdersFailure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchGetReservedOrders(): Generator<void, void, void> {
    yield takeLatest(Types.GET_RESERVED_ORDERS, getReservedOrders);
  }

  /*****
End of Deprecated
*****/

  /* Get Orders */
  function* getOrdersV2(action) {
    try {
      const response = yield call(
        api.orders.getOrdersV2,
        action.query,
        action.print
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getOrdersV2Success(response.data));
        yield put(Actions.getOrderCount(action.query));
      } else {
        yield put(Actions.getOrdersV2Failure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getOrdersV2Failure(error));
    }
  }
  function* watchgetOrdersV2(): Generator<void, void, void> {
    yield takeLatest(Types.GET_ORDERS_V2, getOrdersV2);
  }

  /* Get Single order */
  function* getSingleOrder(action) {
    try {
      const response = yield call(api.orders.getSingleOrder, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getSingleOrderSuccess(response.data));
      } else {
        yield put(
          Actions.getSingleOrderFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getSingleOrderFailure(error));
    }
  }
  function* watchgetSingleOrder(): Generator<void, void, void> {
    yield takeLatest(Types.GET_SINGLE_ORDER, getSingleOrder);
  }

  /* Get Orders */
  function* getOrderCount(action) {
    try {
      const response = yield call(api.orders.getOrderCount, action.query);
      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getOrderCountSuccess(response.data));
      } else {
        yield put(Actions.getOrderCountFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getOrderCountFailure(error));
    }
  }
  function* watchGetOrderCount(): Generator<void, void, void> {
    yield takeLatest(Types.GET_ORDER_COUNT, getOrderCount);
  }

  /* Post Orders */

  function* postOrdersV2(action) {
    try {
      const response = yield call(api.orders.postOrdersV2, action.orders);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.postOrdersV2Success(response.data));
        toast(
          I18n.getText(
            action.orders.is_cancelled || !action.orders.is_accepted
              ? "order.cancelled-success"
              : "order.accept-success"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.postOrdersV2Failure(response.data.error || "Error"));
        toast(response.data.error, { type: "error", className: "errorClass" });
      }
    } catch (error) {
      yield put(Actions.postOrdersV2Failure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchpostOrdersV2(): Generator<void, void, void> {
    yield takeLatest(Types.POST_ORDERS_V2, postOrdersV2);
  }

  /* Get Reserved Orders */
  function* postPickupV2(action) {
    try {
      const response = yield call(
        api.orders.postPickupV2,
        action.query,
        action.remove
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.postPickupV2Success(response.data));
        toast(
          I18n.getText(
            action.remove ? "order.move-to-accepted" : "order.pickup-ready"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.postPickupV2Failure(response.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.postPickupV2Failure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchpostPickupV2(): Generator<void, void, void> {
    yield takeLatest(Types.POST_PICKUP_V2, postPickupV2);
  }

  /* Print Order */
  function* printOrder(action) {
    try {
      const response = yield call(api.orders.printOrder, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.printOrderSuccess(response.data));
      } else {
        yield put(Actions.printOrderFailure(response.error || "error"));
        toast(response.data.error || "error");
      }
    } catch (error) {
      yield put(Actions.printOrderFailure(error));
    }
  }
  function* watchPrintOrder(): Generator<void, void, void> {
    yield takeLatest(Types.PRINT_ORDER, printOrder);
  }


    /* close ASN */

    function* openPickup(action) {
      try {
        const response = yield call(api.orders.openPickup, action.warehouse);

        if (response.ok && {}.hasOwnProperty.call(response, "data")) {
          yield put(Actions.openPickupSuccess(response.data));
          toast(I18n.getText("orders.successful-request"), {
            type: "success",
            className: "successClass"
          });
        } else {
          yield put(Actions.openPickupFailure(response.data.error || "Error"));
          toast(response.data.error || "Error", {
            type: "error",
            className: "errorClass"
          });
        }
      } catch (error) {
        yield put(Actions.openPickupFailure(error));
        toast(error, {
          type: "error",
          className: "errorClass"
        });
      }
    }
    function* watchOpenPickup(): Generator<void, void, void> {
      yield takeLatest(Types.OPEN_PICKUP, openPickup);
    }

  return {
    watchgetSingleOrder,
    watchgetOrdersV2,
    watchpostOrdersV2,
    watchpostPickupV2,
    watchGetOrders,
    watchPostOrders,
    watchGetReservedOrders,
    watchPrintOrder,
    watchGetOrderCount,
    watchOpenPickup
  };
};



// WEBPACK FOOTER //
// ./src/sagas/OrdersSaga.js